const options = {
  5: "bg-gray-400/5",
  10: "bg-gray-400/10",
  25: "bg-gray-400/25",
  50: "bg-gray-400/50",
  75: "bg-gray-400/75",
  90: "bg-gray-400/90",
  100: "bg-gray-400",
};

const from = {
  5: "from-gray-400/5",
  10: "from-gray-400/10",
  25: "from-gray-400/25",
  50: "from-gray-400/50",
  75: "from-gray-400/75",
  90: "from-gray-400/90",
  100: "from-gray-400",
};

export default function getBackgroundGray400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
